import React from "react";
import Page from "components/Page";
import { Props } from "./Workflows";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const Workflows = lazyWithRetry(() => import("./Workflows"));

export default (props: Props) => (
  <Page>
    <Workflows {...props} />
  </Page>
);
